import { Link } from 'react-router';
import { Button } from '@hefesto/ui';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center sm:px-8">
      <p className="font-mono text-sm text-brasa">404</p>
      <h1 className="mt-3 font-display text-3xl font-bold">Esta página no existe</h1>
      <p className="mt-3 text-ceniza">Revisá la dirección o volvé al inicio.</p>
      <Button asChild className="mt-8">
        <Link to="/">Volver al inicio</Link>
      </Button>
    </div>
  );
}
